import { Talent } from "../../Classes";

const tier7 = [
  null,
  new Talent(
    "Moonkin Form",
    "spell_nature_forceofnature",
    [
      "Transforms the Druid into Moonkin Form. While in this form the armor contribution from items is increased by 360% and all party members within 30 yards have their spell critical strike chance increased by 3%. Melee attacks in this form have a chance on hit to regenerate mana based on attack power. The Moonkin can not cast healing spells while shapeshifted. The act of shapeshifting frees the caster of Polymorph and Movement Impairing effects.",
    ],
    1,
    [[]],
    null,
    null,
    "35% of base mana",
    null,
    "Instant",
    null,
    null,
    {
      isNew: false,
      isChanged: true,
      isMoved: false,
    },
  ),
  null,
  null,
];

export default tier7;
